// auth.guard.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from './shared/services/base.service';
import { AuthService } from './shared/services/auth.service';

@Injectable()
export class AuthGuard  {
  constructor(private router: Router) { }

  canActivate() {

    // check if we are refreshing page
    if (!AuthService.authToken) {
      AuthService.authToken = localStorage.getItem('auth_token');
    }

    if (AuthService.authToken) {
      let jwt = AuthService.parseJwt(AuthService.authToken);

      if (Date.now() < jwt.exp * 1000) {
        return true;
      }
    }

    AuthService.logout(this.router);

    this.router.navigate(['/login']);
    return false;
  }
}
